import { UserAccountBalanceRptService } from "../services/UserAccountBalanceRptService";
import { UserAccountBalanceRptConstants } from "../constants/UserAccountBalanceRptConstants";
import { alertActions } from ".";

export const UserAccountBalanceRptActions = {
  getAll,
  loadingData,
  exportData,
};

function getAll(obj) {
  return (dispatch) => {
    dispatch(request());

    UserAccountBalanceRptService.fetchUserloyalityLogData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: UserAccountBalanceRptConstants.GETALL_REQUEST };
  } //Changes
  function success(datas) {
    return { type: UserAccountBalanceRptConstants.GETALL_SUCCESS, datas };
  }
  function successExport(datas) {
    return { type: UserAccountBalanceRptConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: UserAccountBalanceRptConstants.GETALL_FAILURE, error };
  }
}

function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    UserAccountBalanceRptService.fetchUserloyalityLogData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        ;
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.TotalRows;
            delete v.CreatedBy;
            delete v.DocURL;
            delete v.UserloyalityLogId;
            delete v.ProductID;
            delete v.LoyalityTrnsId;
            delete v.SchemeId;
            delete v.UserId;
            delete v.RoleId;
            delete v.SchemeMapingId;
            delete v.ScratchNo;
            delete v.VerificationId;
            delete v.RedeemReqId;
            delete v.Schemecategory;
            delete v.IsApproved;
            delete v.TransId;
            delete v.UpdatedBy;
            delete v.UpdatedDt;
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: UserAccountBalanceRptConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: UserAccountBalanceRptConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: UserAccountBalanceRptConstants.GETEXPORT_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: UserAccountBalanceRptConstants.LOADING_REQUEST,
    isbool,
  };
}
